import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Everything in the Impacts tab that opens OVER the page — a Select's menu, a ⋮
// menu, a confirm Dialog, the impact and activity Drawers, a Popover — is an MUI
// Modal underneath, and a Modal locks page scroll while it is open by setting
// `overflow: hidden` on <body>.
//
// In this app that lock is what throws the page back to the top. The real
// scroller is <html> (`:root { overflow-x: hidden }` in index.css), so MUI locks
// <body> instead, and clipping <body> collapses the document's scrollable height:
// the browser clamps scrollTop to 0, and MUI restores the style on close but
// never the offset.
//
// Here it is fixed once, for the whole tab, so anything added to it later is
// covered without having to remember a prop:
//   • `MuiModal` is the default Dialog and Drawer fall back on;
//   • `MuiPopover` is needed as well, because Popover — and so every Menu and
//     Select menu — passes its OWN `disableScrollLock={false}` down to the Modal,
//     which overrides the Modal default. With the lock off, Popover keeps its
//     paper pinned to the anchor as the page scrolls.
// An overlay has no need to freeze the page behind it — the backdrop already
// takes the clicks.
const withoutScrollLock = (outer) =>
    createTheme(outer, {
        components: {
            MuiModal: { defaultProps: { disableScrollLock: true } },
            MuiPopover: { defaultProps: { disableScrollLock: true } },
        },
    });

export default function KeepScrollPosition({ children }) {
    return <ThemeProvider theme={withoutScrollLock}>{children}</ThemeProvider>;
}
